import React from "react";

interface PropsType {
  /** Accepts "75%" string or 0-100 number */
  completion: string | number;
  /** Optionally force a tone, otherwise it's derived from value */
  tone?: "default" | "success" | "warning" | "danger";
}

/**
 * Local enhanced progress bar for the Subscription Usage page.
 * - Drop-in compatible with the global ProgressBar API (accepts completion as string or number)
 * - Auto-color: ≥90% → danger, ≥75% → warning, otherwise brand gradient
 * - Animates in on mount
 */
const UsageProgressBar: React.FC<PropsType> = ({ completion, tone }) => {
  const parsed =
    typeof completion === "string"
      ? parseFloat(completion.replace("%", ""))
      : completion;
  const pct = Math.min(100, Math.max(0, Number.isFinite(parsed) ? parsed : 0));

  let toneClass = "";
  if (tone === "success") toneClass = "tone-success";
  else if (tone === "warning") toneClass = "tone-warning";
  else if (tone === "danger") toneClass = "tone-danger";
  else if (pct >= 90) toneClass = "tone-danger";
  else if (pct >= 75) toneClass = "tone-warning";

  return (
    <div
      className="ni-usage-progress"
      role="progressbar"
      aria-valuenow={Math.round(pct)}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        className={`ni-usage-progress-fill ${toneClass}`}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
};

export default UsageProgressBar;
